export async function  desN(base64Data: string) {
  const passphrase = localStorage.getItem("SS");

  if (!passphrase) { throw new Error("SS no encontrado"); }

  const salt = localStorage.getItem("ST");

  if (!salt) { throw new Error("ST no encontrado"); }

  const iterations = 1000;

  const encrypted = Uint8Array.from(atob(base64Data), c =>
    c.charCodeAt(0)
  );

  const encoder = new TextEncoder();

  const keyMaterial = await crypto.subtle.importKey(
    "raw",
    encoder.encode(passphrase),
    "PBKDF2",
    false,
    ["deriveBits"]
  );

  const derivedBits = await crypto.subtle.deriveBits(
    {
      name: "PBKDF2",
      salt: encoder.encode(salt),
      iterations,
      hash: "SHA-256"
    },
    keyMaterial,
    48 * 8
  );

  const derivedBytes = new Uint8Array(derivedBits);

  const key = derivedBytes.slice(0, 32);
  const iv  = derivedBytes.slice(32, 48);

  const aesKey = await crypto.subtle.importKey(
    "raw",
    key,
    { name: "AES-CBC" },
    false,
    ["decrypt"]
  );

  const decryptedBuffer = await crypto.subtle.decrypt(
    { name: "AES-CBC", iv },
    aesKey,
    encrypted
  );

  const decoded = new TextDecoder().decode(decryptedBuffer);

  return JSON.parse(decoded);
}

// export const desRes = async (response: any) => {
//   try {
//     if (response?.data) {
//       const des = await desN(response.data);

//       const finalData = des?.data ?? des;

//       if (!finalData) {
//         response.data = finalData;
//         return response;
//       }

//       if (Array.isArray(finalData)) {
//         response.data = {
//           data: finalData
//         };
//       } else {
//         response.data = finalData;
//       }
//     }
//   } catch (err) {
//     console.error("Error al desencriptar:", err);
//   } 

//   return response;
// };

// export const desRes = async (response: any) => {
//   try {
//     if (response?.data) {
//       const des = await desN(response.data);

//       // 🔥 SIEMPRE reemplaza
//       response.data = des;
//     }
//   } catch (err) {
//     console.error("Error al desencriptar:", err);
//   }

//   return response;
// };

export const desRes = async (response: any) => {
  try {
    if (response?.data) {
      const des = await desN(response.data);

      // 🔥 si viene con data interna, la aplano
      if (des?.data) {
        response.data = {
          ...des.data,
          success: des.success,
          message: des.message,
          errors: des.errors
        };
      } else {
        response.data = des;
      }
    }
  } catch (err) {
    console.error("Error al desencriptar:", err);
  }

  return response;
};
